import React, { useEffect } from "react";
import * as Styles from "../common/styles/TradeInAem";
import Hr from "../../../../common-deprecated/styles/v2/toyota/utilities/Hr";
import { TradeInAemLabel } from "../../../utils/labels";
import FindVehicleSearch from "./FindVehicleSearch";
import { TradeInAemSearchType } from "../../../utils/constants";
import FindVehicleResolve from "./FindVehicleResolve";
import FindVehicleResult from "./FindVehicleResult";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import { useTradeInAemDispatch, useTradeInAemSelector } from "../../../redux/store";
import usePreviouslySearchedVehicles from "../../../hooks/usePreviouslySearchedVehicles";
import { trackStepFindVehicle } from "../../../utils/tracking";
import useTrackingParams from "../../../hooks/useTrackingParams";
import { TradeInAemFindVehicleStatus } from "../../../utils/types";
import { showBackCtaOnStepComponent } from "../../../utils/utils";
import * as Button from "../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { IconWrapper } from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { getInternalLink } from "../../../utils/navUtils";

const FindVehicleContainer = (): JSX.Element => {
    const dispatch = useTradeInAemDispatch();
    const csl = useTradeInCsl();
    const showDivider = csl.enableLicensePlate && csl.enableVin;

    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);
    const currentStep = useTradeInAemSelector((state) => state.tradeInAemNav.step);
    const searchResults = useTradeInAemSelector((state) => state.tradeInAemFindVehicle.searchResults);
    const searchInsufficient = useTradeInAemSelector(
        (state) => state.tradeInAemFindVehicle.searchStatus === TradeInAemFindVehicleStatus.Insufficient,
    );

    const { previouslySearchedResults, addToPreviouslySearched, removeFromPreviouslySearched } =
        usePreviouslySearchedVehicles();
    const trackingParams = useTrackingParams();

    const prevStep = getInternalLink(csl, currentStep, dispatch, commonSettings, "prev");

    useEffect(() => {
        trackStepFindVehicle(trackingParams);
    }, []);

    const showResolve = csl.enableResolve || searchInsufficient;

    return (
        <Styles.Main>
            <Styles.Container>
                {csl.enableLicensePlate && <FindVehicleSearch type={TradeInAemSearchType.LicensePlate} />}
                {showDivider && (
                    <Styles.TextDivider>
                        <TradeInAemLabel label="tradeInAemFindVehicleOr" />
                    </Styles.TextDivider>
                )}
                {csl.enableVin && <FindVehicleSearch type={TradeInAemSearchType.VinNumber} />}
                {showResolve && <FindVehicleResolve />}
                {searchResults && (
                    <Styles.VehicleResults>
                        {searchResults.map((result) => (
                            <FindVehicleResult
                                key={csl.getVehicleKey(result)}
                                vehicle={result}
                                addToPreviouslySearched={addToPreviouslySearched}
                            />
                        ))}
                    </Styles.VehicleResults>
                )}
                {!!previouslySearchedResults?.length && (
                    <>
                        <Hr my={5} />
                        <TradeInAemLabel label="tradeInAemFindVehiclePreviouslySearchedVehicles" />
                        <Styles.VehicleResults mt={3}>
                            {previouslySearchedResults.map((result) => (
                                <FindVehicleResult
                                    key={csl.getVehicleKey(result)}
                                    vehicle={result}
                                    removeFromPreviouslySearched={removeFromPreviouslySearched}
                                />
                            ))}
                        </Styles.VehicleResults>
                    </>
                )}

                {showBackCtaOnStepComponent(currentStep, csl.enabledNavSteps) && (
                    <Button.Link m={0} as="a" href={prevStep.href} onClick={prevStep.onClick} hasIcon>
                        <IconWrapper>
                            <Icon variant="arrowLeft" />
                        </IconWrapper>
                        <Text.Button>
                            <TradeInAemLabel label="tradeInAemBack" />
                        </Text.Button>
                    </Button.Link>
                )}
            </Styles.Container>
        </Styles.Main>
    );
};
export default FindVehicleContainer;
